import PropTypes from 'prop-types';
import ExperimentUtil from '../../utils/ExperimentUtil';
import { isConfirmAddressFeatureEnabled } from '../../utils/ExperimentsUtil';
import { getFuzzyLatLng } from '../../utils/LocationUtil';
import LeadActions from '../../actions/lead';
import AppActions from '../../actions/app';
import JoinDetailsAction from '../../actions/joinDetails';

// might want to start actually testing this logic
/* istanbul ignore next */
const mapStateToProps = (state) => {
    const {
        app, joinDetails, location, google, lead
    } = state;
    const { fingerprint, features } = app;
    const { placeId } = google;
    const {
        address, addressValidation, latLng, serverAddressValidation, geocoderLatLng,
        partialMatch
    } = location;
    const {
        emailOptOut,
        titleName,
        firstName,
        lastName,
        latinFirstName,
        latinLastName,
        email,
        password,
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        propertyId
    } = lead;
    const {
        propertyName, propertyType, unitCount, currency, managerInfo, chainInfo, latinPropertyName,
        competitorUrl, websiteUrl
    } = joinDetails;

    const isUnicode = !Object.keys(addressValidation).reduce(
        (acc, x) => acc && addressValidation[x].isLatin,
        true
    );

    const experimentUtil = new ExperimentUtil(app.experiments);
    const isAddressV2 = features.isConventionalLodgingFlow || isConfirmAddressFeatureEnabled(experimentUtil);

    const parseAddressForLatLng = () => {
        const fromMap = false;
        const fromGeo = true;

        const result = getFuzzyLatLng(
            isAddressV2,
            serverAddressValidation,
            latLng,
            geocoderLatLng,
            partialMatch
        );
        return {
            ...result,
            fromMap,
            fromGeo
        };
    };
    const latLngDetails = parseAddressForLatLng();
    return {
        useThreeLetterCountryCode: features.useThreeLetterCountryCode,
        emailOptOut,
        // contact information
        titleName,
        firstName,
        lastName,
        latinFirstName,
        latinLastName,
        email,
        locale: app.locale.canonical,
        password,
        // phone number
        phoneCountryCode,
        phoneCountryCodeDigits,
        phoneNumber,
        // property information
        competitorUrl,
        propertyName,
        latinPropertyName,
        currency,
        propertyType,
        managerInfo,
        chainInfo,
        unitCount,
        websiteUrl,
        // address information
        address,
        placeId,
        latLngDetails,
        partialMatch,
        isAddressV2,
        isUnicode,
        // risk details
        fingerprint,
        propertyId
    };
};

/* istanbul ignore next */
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({
    // sets joinId
    setJoinId: (joinId) => dispatch(LeadActions.setJoinId(joinId)),
    setPropertyId: (propertyId) => dispatch(LeadActions.setPropertyId(propertyId)),
    setUserId: (userId) => dispatch(LeadActions.setUserId(userId)),
    setEligibilityStatus: (reason) => dispatch(LeadActions.setEligibilityStatus(reason)),
    onSubmitError: () => dispatch(LeadActions.setLeadCreationError(true)),
    // app actions
    setCreateAccountSuccess: () => dispatch(AppActions.setCreateAccountSuccess()),
    setCreateAccountFail: (error) => dispatch(AppActions.setCreateAccountFail(error)),
    // join details actions
    clearCompetitorUrl: () => dispatch(JoinDetailsAction.setCompetitorUrl('')),
    setSubmarketId: (submarketId) => dispatch(JoinDetailsAction.setSubmarketId(submarketId)),
    clearSubmarketId: () => dispatch(JoinDetailsAction.clearSubmarketId()),
    setIsSelfServe: (isSelfServe) => dispatch(JoinDetailsAction.setIsSelfServe(isSelfServe)),
    clearIsSelfServe: () => dispatch(JoinDetailsAction.clearIsSelfServe())
});

const proptypes = {
    children: PropTypes.node.isRequired,
    useThreeLetterCountryCode: PropTypes.bool.isRequired,
    // parameters for PartnerContactInput
    titleName: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    latinFirstName: PropTypes.string.isRequired,
    latinLastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    locale: PropTypes.string,
    password: PropTypes.string,
    phoneCountryCode: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    emailOptOut: PropTypes.bool.isRequired,
    fingerprint: PropTypes.shape({
        orgId: PropTypes.string,
        deviceId: PropTypes.string
    }).isRequired,
    propertyName: PropTypes.string.isRequired,
    latinPropertyName: PropTypes.string.isRequired,
    address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        postalCode: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    isUnicode: PropTypes.bool.isRequired,
    placeId: PropTypes.string.isRequired,
    propertyType: PropTypes.string.isRequired,
    unitCount: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    managerInfo: PropTypes.string.isRequired,
    chainInfo: PropTypes.string.isRequired,
    latLngDetails: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        fuzzy: PropTypes.bool,
        fromMap: PropTypes.bool,
        fromGeo: PropTypes.bool
    }),
    isAddressV2: PropTypes.bool.isRequired,
    partialMatch: PropTypes.bool.isRequired,
    competitorUrl: PropTypes.string.isRequired,
    websiteUrl: PropTypes.string.isRequired,
    submarketId: PropTypes.string,
    // end of join fields
    // redux actions
    // lead actions
    setJoinId: PropTypes.func.isRequired,
    setPropertyId: PropTypes.func.isRequired,
    setUserId: PropTypes.func.isRequired,
    setEligibilityStatus: PropTypes.func.isRequired,
    onSubmitError: PropTypes.func.isRequired,
    // app actions
    setCreateAccountSuccess: PropTypes.func.isRequired,
    setCreateAccountFail: PropTypes.func.isRequired,
    // join details actions
    clearCompetitorUrl: PropTypes.func.isRequired,
    setSubmarketId: PropTypes.func.isRequired,
    clearSubmarketId: PropTypes.func.isRequired,
    setIsSelfServe: PropTypes.func.isRequired,
    clearIsSelfServe: PropTypes.func.isRequired,
    // pageflow
    pageFlow: PropTypes.shape({
        next: PropTypes.func,
        nextPageLink: PropTypes.func
    }).isRequired
};

const defaultProps = {
    submarketId: undefined
};

export {
    mapStateToProps,
    mapDispatchToProps,
    proptypes,
    defaultProps
};
